import { useEffect, useState } from "react"
import { Coupon } from "./interface"
import ApiService from "../../service/ApiService"
import { apiPaths } from "../../service/apiPaths"
import toast from "react-hot-toast"
import { useNavigate } from "react-router-dom"
import { GridColDef, GridFilterModel, GridSortModel } from "@mui/x-data-grid";

const useCoupon = (columns: GridColDef[]) => {
  const navigate = useNavigate()
  const [selectedCouponId, setSelectedCouponId] = useState<String>("")
  const [loading, setLoading] = useState<boolean>(false)
  const [filterModel, setFilterModel] = useState<GridFilterModel>();
  const [sortingModel, setSortingModel] = useState<GridSortModel>();
  // New state for dedicated time sorting
  const [timeSortOrder, setTimeSortOrder] = useState<'asc' | 'desc' | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [paginationModel, setPaginationModel] = useState({
    page: 0, // DataGrid is 0-indexed
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0); // Total number of rows

  const [couponData, setCouponData] = useState<Coupon[]>([])

  const fetchAllCoupons = async () => {
    try {
      const params: any = {
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
        filters: filterModel?.items.map(({ field, operator, value }) => ({
          field,
          type: columns?.find((col) => col.field === field)?.type || "string",
          operator,
          value,
        })),
        // Prioritize timeSortOrder, otherwise use the grid's sortingModel
        sortBy: timeSortOrder ? "createdAt" : sortingModel?.[0]?.field || "",
        sortOrder: timeSortOrder || sortingModel?.[0]?.sort || undefined,
      };

      // Add search query parameter if provided
      if (searchQuery && searchQuery.trim().length > 0) {
        params.q = searchQuery.trim();
      }

      const data = await ApiService({
        method: "GET",
        endpoint: apiPaths.coupons,
        params

      })

      console.log("Coupons : ", data)
      if (data?.data) {
        setCouponData(data?.data || []);
        setRowCount(data?.totalCount || 0);
      } else {
        setCouponData(data || []);
        setRowCount(0);
      }

    } catch (err) {
      console.log(err)

    }

  }

  function handleEdit(id: string) {
    try {



    } catch (err) {

    }

  }

  const handleDelete = async (id: string) => {
    setLoading(true);
    try {
      await ApiService({
        method: "DELETE",
        endpoint: `${apiPaths.deleteCoupon}/${id}`
      })
      toast.success("Coupon category deleted successfully");
      fetchAllCoupons()
    } catch (error) {
      console.error("Error deleting coupon category:", error);
      toast.error("Failed to delete coupon category");
    } finally {
      setLoading(false);
    }
  };


  function handleAdd() {
    navigate("/add-coupon")
  }

  // New handler to cycle through time sorting options
  const handleSortByTime = () => {
    // When using this button, clear the grid's own sort model
    setSortingModel([]);
    setTimeSortOrder((prev) => {
      if (prev === "desc") return "asc";
      if (prev === "asc") return null; // Turn off
      return "desc"; // Start with descending
    });
  };


  // Debounced search effect
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      fetchAllCoupons();
    }, 500); // 500ms debounce delay

    return () => clearTimeout(debounceTimer);
  }, [searchQuery]);

  useEffect(() => {
    fetchAllCoupons()
  }, [paginationModel, filterModel, sortingModel, timeSortOrder]) // Added timeSortOrder to dependencies

  // Effect to reset time sort when grid sort is used
  useEffect(() => {
    if (sortingModel && sortingModel.length > 0) {
      setTimeSortOrder(null);
    }
  }, [sortingModel]);
  return { fetchAllCoupons, selectedCouponId, handleDelete, handleEdit, setSelectedCouponId, loading, setLoading, handleAdd, couponData, searchQuery, setSearchQuery, setFilterModel, setSortingModel, rowCount, paginationModel, setPaginationModel, handleSortByTime, timeSortOrder }



}


export default useCoupon